var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import ReactModal from 'react-modal';
import styled from 'styled-components';
// Make sure to bind the modal to your appElement
// https://reactcommunity.org/react-modal/accessibility/
// https://github.com/reactjs/react-modal/issues/632
/* istanbul ignore next */
ReactModal.setAppElement(process.env.NODE_ENV === 'test' ? document.createElement('div') : '#root');
ReactModal.defaultStyles.overlay.backgroundColor = 'rgba(0, 0, 0, 0.3)';
var getWidth = function (_a) {
    var small = _a.small, large = _a.large;
    if (small) {
        return '25rem';
    }
    if (large) {
        return '50rem';
    }
    return '37.5rem';
};
var Modal = styled(ReactModal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  outline: none;\n\n  @media (min-width: ", ") {\n    width: ", ";\n    max-width: calc(100% - 2 * ", ");\n    /* IE11 fails to calculate a correct element height if height: auto is set here. min-height seems to work well but I have no idea what setting min-height to auto is supposed to accomplish */\n    min-height: auto;\n    max-height: calc(100% - 2 * ", ");\n    margin: ", " auto;\n    overflow: hidden;\n    box-shadow: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  outline: none;\n\n  @media (min-width: ", ") {\n    width: ", ";\n    max-width: calc(100% - 2 * ", ");\n    /* IE11 fails to calculate a correct element height if height: auto is set here. min-height seems to work well but I have no idea what setting min-height to auto is supposed to accomplish */\n    min-height: auto;\n    max-height: calc(100% - 2 * ", ");\n    margin: ", " auto;\n    overflow: hidden;\n    box-shadow: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.global.breakpoints.desktop;
}, getWidth, function (_a) {
    var component = _a.theme.component;
    return component.modal.margin;
}, function (_a) {
    var component = _a.theme.component;
    return component.modal.margin;
}, function (_a) {
    var component = _a.theme.component;
    return component.modal.margin;
}, function (_a) {
    var component = _a.theme.component;
    return component.modal.boxShadow;
});
export default Modal;
var templateObject_1;
//# sourceMappingURL=index.js.map